/** Accept the digits used by Arabic keyboards without changing the OTP value. */
export function normalizeAuthDigits(value: string): string {
  return value.replace(/[٠-٩۰-۹]/g, (digit) => String(digit.charCodeAt(0) - (digit <= '٩' ? 0x0660 : 0x06f0)))
}

export function normalizeOtpInput(value: string): string {
  return normalizeAuthDigits(value).replace(/\D/g, '').slice(0, 6)
}

export function normalizePhoneInput(value: string): string {
  const compact = normalizeAuthDigits(value).replace(/[\s()-]/g, '')
  return compact.startsWith('05') ? `+966${compact.slice(1)}` : compact
}
